import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  public logoutEmitterSubject$: Subject<void> = new Subject();
  constructor() {}
}
